import React from 'react';
import ShowEntityData from '../../../../Elements/ShowEntityData';
import TpClientInvoiceItem from '../../../../Domain/TpClientInvoiceItem';
import TpClientInvoiceService from '../../../../Services/TpClientInvoiceService';

export default class TpClientInvoiceDetailsInfoTab extends React.Component {
  static defaultProps = {
    tpClientInvoiceId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <ShowEntityData
        itemId={this.props.tpClientInvoiceId}
        type={TpClientInvoiceItem}
        serviceGetByIdFunction={TpClientInvoiceService.GetById}
      />
    );
  }
}
